import React from 'react';
import CategoryPage from '../components/category/CategoryPage';

function RajnitiPage({ onOpen }) {
  return <CategoryPage onOpen={onOpen} title="राजनीति" catSlug="politics" color="#2457A8" />;
}

export default RajnitiPage;